import { is } from "ramda";
import api from "api/flexapi";
import * as actionTypes from "./delegationActionTypes";
import { SubmissionError } from "redux-form";

// Get list of employee delegation
export const getDelegationList = () => dispatch => {
  dispatch({
    type: actionTypes.FETCH_DELEGATION_LIST_BEGIN,
    payload: { isfetching: true },
  });

  api
    .getDelegationList()
    .then(({ body }) => {
      dispatch({
        type: actionTypes.FETCH_DELEGATION_LIST_SUCCESS,
        payload: {
          employees: [].concat(...body),
          isfetched: true,
          isfetching: false,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.FETCH_DELEGATION_LIST_ERROR,
        payload: {
          error: err.response ? err.response.body : err,
          isfetched: true,
          isfetching: false,
        },
      });
    });
};

// Search employee delegation
export const getEmployeeDelegation = data => dispatch => {
  dispatch({
    type: actionTypes.FETCH_EMPLOYEE_DELEGATION_LIST_BEGIN,
    payload: { isfetching: true },
  });

  api
    .getEmployeeDelegation(data)
    .then(({ body }) => {
      const transformData = ({ employeeList = [], ...rest }) => {
        const employees = employeeList.map(obj => {
          if (obj.employeeID) {
            const { employeeID, ...restEmployee } = obj;
            return {
              employeeId: employeeID,
              ...restEmployee,
            };
          }
        });

        return {
          ...rest,
          employeeList: employees,
        };
      };
      dispatch({
        type: actionTypes.FETCH_EMPLOYEE_DELEGATION_LIST_SUCCESS,
        payload: {
          search: {
            results: transformData(body),
          },
          isfetched: true,
          isfetching: false,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.FETCH_EMPLOYEE_DELEGATION_LIST_ERROR,
        payload: {
          error: err.response ? err.response.body : err,
          isfetched: true,
          isfetching: false,
        },
      });
    });
};

export const checkEmployeeDelegation = data => dispatch => {
  dispatch({
    type: actionTypes.POST_CHECK_EMPLOYEE_DELEGATION_BEGIN,
    payload: { isChecking: true, isChecked: false, error: {} },
  });

  const { employeeKey: delegateToEmployeeKey, delegate, fromDate, endDate } = data;

  const meta = {
    delegateToEmployeeKey,
    function: delegate,
    from: fromDate,
    to: endDate,
  };

  return api
    .postCheckEmployeeDelegation(meta)
    .then(() => {
      dispatch({
        type: actionTypes.POST_CHECK_EMPLOYEE_DELEGATION_SUCCESS,
        payload: { isChecking: false, isChecked: true },
      });
    })
    .catch(({ response: { body } }) => {
      dispatch({
        type: actionTypes.POST_CHECK_EMPLOYEE_DELEGATION_ERROR,
        payload: { isChecking: false, error: is(Object, body) ? body : { message: body } },
      });
    });
};

export const addEmployeeDelegation = data => dispatch => {
  dispatch({ type: actionTypes.POST_ADD_EMPLOYEE_DELEGATION_LIST_BEGIN });

  const { employeeKey: delegateToEmployeeKey, delegate, fromDate, endDate } = data;

  const meta = {
    delegateToEmployeeKey,
    function: delegate,
    from: fromDate,
    to: endDate,
  };

  return api.postAddEmployeeDelegation(meta).catch(({ response: { body } }) => {
    throw new SubmissionError({ _error: body });
  });
};

export const updateEmployeeDelegation = data => dispatch => {
  dispatch({ type: actionTypes.POST_EDIT_EMPLOYEE_DELEGATION_LIST_BEGIN });

  const { entityKey, delegate, fromDate, endDate } = data;

  const meta = {
    delegateKey: entityKey,
    function: delegate,
    from: fromDate,
    to: endDate,
  };

  return api.postEditEmployeeDelegation(meta).catch(({ response: { body } }) => {
    throw new SubmissionError({ _error: body });
  });
};

export const revokeDelegation = ({ entityKey: delegateKey }) => dispatch => {
  dispatch({
    type: actionTypes.POST_REVOKE_DELEGATION_BEGIN,
    payload: { isfetching: true },
  });

  return api
    .postRevokeDelegation({ delegateKey })
    .then(({ body }) => {
      dispatch({
        type: actionTypes.POST_REVOKE_DELEGATION_SUCCESS,
        payload: {
          body,
          isfetched: true,
          isfetching: false,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.POST_REVOKE_DELEGATION_ERROR,
        payload: {
          error: err.response ? err.response.body : err,
          isfetched: true,
          isfetching: false,
        },
      });

      return Promise.reject(err);
    });
};

export const clearSearchDelegationData = () => {
  return {
    type: actionTypes.CLEAR_SEARCH_DELEGATION_DATA,
  };
};



// WEBPACK FOOTER //
// ./actions/delegationActions.js